import { Grid } from '@mui/material';

const PiraeusBankForm = () => {
    return (
        <Grid item xs={12}>
            <form id="paymentForm_Piraeus" method="POST">
                <input id="AcquirerId" name="AcquirerId" type="hidden" />
                <input id="MerchantId" name="MerchantId" type="hidden" />
                <input id="PosId" name="PosId" type="hidden" />
                <input id="User" name="User" type="hidden" />
                <input id="LanguageCode" name="LanguageCode" type="hidden" />
                <input id="MerchantReference" name="MerchantReference" type="hidden" />
                <input id="ParamBackLink" name="ParamBackLink" type="hidden" />
                {/* ---- optional fields ----  */}
                <input id="BillAddrCity" name="BillAddrCity" type="hidden" />
                <input id="BillAddrCountry" name="BillAddrCountry" type="hidden" />
                <input id="BillAddrLine1" name="BillAddrLine1" type="hidden" />
                <input id="BillAddrPostCode" name="BillAddrPostCode" type="hidden" />
                <input id="Email" name="Email" type="hidden" />
                <input id="HomePhone" name="HomePhone" type="hidden" />
            </form>
        </Grid>
    );
};

export default PiraeusBankForm;
